import { render, staticRenderFns } from "./CookieBar.vue?vue&type=template&id=05325f6b&scoped=true&"
import script from "./CookieBar.vue?vue&type=script&lang=js&"
export * from "./CookieBar.vue?vue&type=script&lang=js&"
import style0 from "./CookieBar.vue?vue&type=style&index=0&id=05325f6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05325f6b",
  null
  
)

export default component.exports